<template>
    <div>
        <Transition
            name="fade"
            mode="out-in"
        >
            <div
                class="Settings"
            >
                <PageTitle class="Settings-title">
                    {{ $t('personal-account.settings.title') }}
                </PageTitle>
                <div class="Settings-globalContainer">
                    <div class="Settings-container">
                        <Block
                            :withoutPadding="true"
                        >
                            <List :items="settings">
                                <template #listItem="{item}">
                                    <div
                                        class="Settings-item"
                                        :data-cy="item.dataCy"
                                        @click="item.action"
                                    >
                                        <span
                                            class="Settings-itemIcon"
                                            :class="item.icon"
                                        />
                                        {{ $t(item.translationKey) }}
                                    </div>
                                </template>
                            </List>
                        </Block>
                    </div>
                </div>
            </div>
        </Transition>
        <Transition
            name="fade"
            mode="out-in"
        >
            <FullScreenModal
                :showModal="showSuccessModal"
                type="success"
                :contentStyle="{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    height: '100%',
                    paddingBottom: '120px',
                    overflowX: 'hidden',
                    overflowY: 'auto'
                }"
                :contentSlotStyle="{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexGrow: '1',
                    margin: '0 20px',
                }"
            >
                <div class="SuccessModal">
                    <div class="SuccessModal-icon">
                        <span class="f2m-check" />
                    </div>
                    <div
                        class="SuccessModal-message"
                        v-html="$t(`personal-account.settings.success.message.${optedIn ? 'unsubscribe' : 'subscribe'}`)"
                    />
                </div>
            </FullScreenModal>
        </Transition>
    </div>
</template>

<script>
import PageTitle from '@/components/PageTitle.vue';
import Transition from "@/components/Transition.vue";
import {Block} from "@free2move/vuejs-components";

import List from "@/components/List.vue";
import Vue from "vue";
import Component from "vue-class-component";
import {getSlug} from "@/router";
import FullScreenModal from "@/components/FullScreenModal.vue";

@Component({
    components: {
        FullScreenModal,
        List,
        PageTitle,
        Transition,
        Block,
    },
})
export default class Settings extends Vue {
    data() {
        return {
            showSuccessModal: false,
            optedIn: false
        }
    }

    get settings() {
        return [
            {
                translationKey: "personal-account.settings.terms-and-conditions",
                icon: "f2m-cgu",
                action: this.termsAndConditions,
                dataCy: "button.termsAndConditions"
            },
            {
                translationKey: "personal-account.settings.download-data",
                icon: "f2m-download",
                action: this.downloadData,
                dataCy: "button.downloadData"
            },
            {
                translationKey: "personal-account.settings.newsletter",
                icon: "f2m-megaphone",
                action: this.gotToNewsletter,
                dataCy: "button.newsletter"
            },
            {
                translationKey: "personal-account.settings.logout",
                icon: "f2m-power",
                action: this.logout,
                dataCy: "button.logout"
            }
        ];
    }
    downloadData() {
        this.$router.push({name: "personalAccountDownloadData"})
    }

    logout() {
        const slug = getSlug(this.$language, this.$country, "logout", true);
        window.location.href = `/${this.$language}-${this.$country}/${slug}`;
    }

    termsAndConditions() {
        const slug = getSlug(this.$language, this.$country, "legal", true);
        window.location.href = `/${this.$language}-${this.$country}/${slug}`;
    }

    gotToNewsletter() {
        this.$router.push({name: "personalAccountNewsletter"})
    }
}
</script>

<style lang="scss" scoped>
.Settings {
    width: 100%;

    @media (max-width: $f2m-desktop-breakpoint) {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        min-height: calc(100vh - 150px);
        position: relative;
    }


    &-container {
        flex-grow:1;
        margin-bottom: 56px;

        @media (max-width: $f2m-desktop-breakpoint) {
            max-width: 100%;
        }

    }

    &-globalContainer {
        display: flex;
        gap: 38px;

        @media (max-width: $f2m-desktop-breakpoint) {
            gap: 0;
        }
    }

    &-title {
        margin-bottom: 60px;
    }

    &-item{
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 0 28px;
        cursor: pointer;
        font-size: 18px;
        line-height: 22px;

        &:hover {
            background-color: whitesmoke;
            border-radius: 10px;
        }
    }

    &-itemIcon {
        font-size: 40px;
        color: $color-f2m-purple-icon;
    }
}
.SuccessModal{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: $color-white;
    font-size: 30px;
    line-height: 36px;
    text-align: center;

    &-icon{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        min-height: 119px;
        min-width: 119px;
        border: 2px solid $color-white;
        border-radius: 50%;
        margin-bottom: 21px;

        span{
            font-size: 50px;
        }
    }

    &-verifiedEmail {
        max-width: 200px;
    }

    &-resetPassword {
        max-width: 500px;
        text-align: left;
    }
}
</style>
